module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-tired.6958754a.png";